import React, { useState, useEffect } from 'react';
import PopularSurahSlide from './PopularSurahSlide';
import AlimLoader from '../ui-elements/AlimLoader';
import { useStore } from '@nanostores/react';
import { zamzamSurahs } from '../../stores/sessionStore';
import PopularSurahSkelton from './PopularSurahSkelton';

const PopularSurahContainer = ({parentCompType, sectionTitle}) => {
    const [isPlaylistLoaded,setIsPlaylistLoaded]=useState(false);
    const zamzamPlaylist=useStore(zamzamSurahs);

    useEffect(()=>{
        if(zamzamPlaylist!==null&&!isPlaylistLoaded)
        {
            setIsPlaylistLoaded(true);
        }
    },[zamzamPlaylist]);

    return (
        <div className='' style={{ minHeight: "300px" }}>
            {
                isPlaylistLoaded ? 
                    <>
                        <p id="recent-insights-title" className="alim-text-color-style text-base mt-6 mb-3 font-medium">{sectionTitle?sectionTitle:"Popular surahs"}</p>
                        <PopularSurahSlide alimPlaylist={zamzamPlaylist} parentCompType={parentCompType}/>
                    </>
                : 
                    <>
                        <p id="recent-insights-title" className="alim-text-color-style text-base mt-6 mb-3 font-medium">{sectionTitle?sectionTitle:"Popular surahs"}</p>
                        <PopularSurahSkelton/>
                    </>
            }
        </div>
    );
};

export default PopularSurahContainer;
